import { RegistryItem } from "@schemas/agreementconditions/schema";
import { AgreementConditionType } from "__generated__/graphql";

export const ReeferCheckTypeSchema: RegistryItem = {
	[AgreementConditionType.ReeferCheckType]: {
		fields: {
			"conditions.reeferCheckType": {
				path: "reeferCheckType",
				rules: {
					required: true,
				},
			},
		},
		toInput: (form) => ({
			reeferCheckType: form.reeferCheckType,
		}),
		toForm: (condition) => ({
			reeferCheckType: condition.reeferCheckType ?? undefined,
		}),
	},
};
